import { render, staticRenderFns } from "./PageMainLanguage.vue?vue&type=template&id=0abc4e18&scoped=true&"
import script from "./PageMainLanguage.vue?vue&type=script&lang=js&"
export * from "./PageMainLanguage.vue?vue&type=script&lang=js&"
import style0 from "./PageMainLanguage.vue?vue&type=style&index=0&id=0abc4e18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abc4e18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardTitle,VContainer})
